import React from 'react';
import {Typography, Tag} from 'antd';

import {format, FORMAT_LONG_ALL} from '@/util/dateUtils';

const {Text} = Typography;

const columnDefines = () => ({
    jobName: {
        title: '任务名称',
        dataIndex: 'jobName',
    },
    jobGroup: {
        title: '任务组名',
        dataIndex: 'jobGroup',
        render: text => {
            if (text == 'DEFAULT') {
                return <Tag color="green">默认</Tag>;
            } else if (text == 'SYSTEM') {
                return <Tag color="green">系统</Tag>;
            } else if (text == 'MEDIA') {
                return <Tag color="green">图文</Tag>;
            }
            return '';
        },
    },
    invokeTarget: {
        title: '调用目标字符串',
        dataIndex: 'invokeTarget',
    },
    jobMessage: {
        title: '日志信息',
        dataIndex: 'jobMessage',
    },
    status: {
        title: '状态',
        dataIndex: 'status',
        render: text => {
            if (text == '0') {
                return <Tag color="#108ee9">成功</Tag>;
            } else if (text == '1') {
                return <Tag color="#f50">失败</Tag>;
            } else {
                return '';
            }
        },
    },
    createTime: {
        title: '执行时间',
        dataIndex: 'createTime',
        width: 150,
        render: text => {
            return <Text>{format(text, FORMAT_LONG_ALL)}</Text>;
        },
    },
});

export function getColumns(keys) {
    return keys.map(key => columnDefines()[key]).filter(Boolean);
}
